import CheckCircle from "@untitled-ui/icons-react/build/esm/CheckCircle";
import styled from "styled-components";

// #region SCOPED CSS
const StyledConfirmationContent = styled.div`
    color: var(--text-icons-gray-100, #d1d1d1);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .confirmation-summary {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 24px;
        text-align: center;
    }

    .confirmation-includes {
        align-self: stretch;
        background: var(--backgrounds-lines-n-600, #10141b);
        border-radius: 4px;
        padding: 18px 20px 24px;
    }

    .confirmation-includes-title {
        color: var(--text-icons-green-500, #00bb00);
        font-size: 16px;
        font-weight: 700;
        line-height: 25px;
        margin-bottom: 18px;
        text-align: center;
    }

    .confirmation-includes-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .confirmation-includes-item {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 16px;
        line-height: 24px;
        text-align: left;
    }

    .confirmation-includes-icon {
        color: var(--text-icons-green-500, #00bb00);
        flex-shrink: 0;
        height: 24px;
        width: 24px;
    }

    .confirmation-follow-up,
    .confirmation-question {
        font-size: 16px;
        line-height: 25px;
        text-align: center;
    }

    .confirmation-follow-up {
        margin-top: 24px;
    }

    .confirmation-question {
        margin: 24px 0 18px;
    }

    @media (max-width: 600px) {
        .confirmation-summary,
        .confirmation-follow-up,
        .confirmation-question,
        .confirmation-includes-title {
            font-size: 15px;
            line-height: 22px;
        }

        .confirmation-includes {
            padding: 16px;
        }

        .confirmation-includes-item {
            font-size: 14px;
            line-height: 20px;
        }

        .confirmation-includes-icon {
            height: 20px;
            width: 20px;
        }
    }
`;
// #endregion SCOPED CSS

/** Renders the plan-specific content inside the shared confirmation popup. */
export default function ContentSubscriptionConfirmation({ confirmation }) {
    return (
        <StyledConfirmationContent>
            <div className="confirmation-summary">
                <span>{confirmation.description}</span>
                <span>{confirmation.monthlyPrice}</span>
                <span>{confirmation.quarterlyBilling}</span>
                <span>{confirmation.renewal}</span>
            </div>

            <div className="confirmation-includes">
                <div className="confirmation-includes-title">{confirmation.includesTitle}</div>
                <div className="confirmation-includes-list">
                    {confirmation.includedItems.map(item => (
                        <div className="confirmation-includes-item" key={item}>
                            <CheckCircle className="confirmation-includes-icon" />
                            <span>{item}</span>
                        </div>
                    ))}
                </div>
            </div>

            {confirmation.followUp && <div className="confirmation-follow-up">{confirmation.followUp}</div>}
            <div className="confirmation-question">{confirmation.question}</div>
        </StyledConfirmationContent>
    );
}
